export default "__VITE_ASSET__cb96b48b__"